var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.banner.img)?_c('div',[(_vm.loading)?[_c('v-skeleton-loader',{attrs:{"type":"image","height":"145"}})]:[_c('dynamic-link',{attrs:{"to":_vm.banner.link,"append-class":"text-reset d-block lh-0"}},[_c('img',{staticClass:"img-fluid w-100",attrs:{"src":_vm.banner.img,"alt":_vm.appName}})])]],2):_vm._e()
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }